import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomLeft32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconRadiusBottomLeft32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 10.678V15.5a9 9 0 0 0 9 9h4.922a1 1 0 1 1 0 2H16c-6.075 0-11-4.925-11-11v-4.822a1 1 0 1 1 2 0m7.762-4.457a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M11 4.97a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m13.512 16a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m1.25-12.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-1.25 6.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-3.789-10.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomLeft32);
